// extracted by mini-css-extract-plugin
export default {"root":"YZBKvNG0UbK_WPFChVk4","placeHolderShimmer":"B8yQsnxM6VwqvOr2xfeb"};